// extracted by mini-css-extract-plugin
module.exports = {"description":"_a3a2012","heading":"_4288b55"};